import React from 'react'

import clsx from 'clsx'

import { BaseButton } from 'components/Button'

import classes from './MenuItem.module.scss'

/** @type {import('./types').default} */
const MenuItem = ({ children, className, selected = false, value, ...other }) => (
  <BaseButton
    component="li"
    className={clsx('MenuItem', classes.root, selected && classes.selected, className)}
    data-value={value}
    {...other}
  >
    {children}
  </BaseButton>
)

export default MenuItem
